import React from 'react';
import { PracticeSwitcher } from './PracticeSwitcher';
import { LocationSwitcher } from './LocationSwitcher';
import { UserMenu } from './UserMenu';
import styles from './TopBar.module.css';

interface TopBarProps {
  practiceName?: string;
}

function currentMonthYear() {
  return new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

export function TopBar({ practiceName }: TopBarProps) {
  return (
    <header className={styles.topBar}>
      <div className={styles.left}>
        <PracticeSwitcher fallbackName={practiceName} />
        <div className={styles.subtitle}>{currentMonthYear()}</div>
      </div>

      <div className={styles.right}>
        <LocationSwitcher />
        <UserMenu />
      </div>
    </header>
  );
}
